import gql from 'graphql-tag';

const UCI_SYNC_MEMBER = gql`
mutation issSyncMember($memberId: ID!, $background: Boolean ) {
  issSyncMember(memberId: $memberId, background: $background) 
}
`;

export default UCI_SYNC_MEMBER;